<h1 mat-dialog-title class="">
  <span class="w-100 h5 m-0">
    <span class="d-inline-block list-row-icon">
      <i class="rt-icon rt-info fs30 me-2"></i>
      {{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.TITLE' | translate }}
    </span>
  </span>
</h1>
<div mat-dialog-content class="w-100 bg-white pb-0">
  <div class="row m-0" style="word-break: break-word;">

    <div class="col-12 py-1">
      <mat-label class="w-100 d-block mb-0 fw-bold">
        <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NAME' | translate }} </span>
      </mat-label>
      <div class="w-100">
        <span *ngIf="docInfo?.Name">
          {{docInfo?.Name}}
        </span>
        <span class="d-inline-block" *ngIf="!docInfo?.Name">
          {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
        </span>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-6 py-1">
      <mat-label class="w-100 d-block mb-0 fw-bold">
        <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.IS-SIGNING' | translate }} </span>
      </mat-label>
      <div class="w-100">
        <span *ngIf="docInfo?.IsSignaturesPresent">
          <i class="rt-icon rt-fill-success and-text text-success justify-content-start me-1"></i>
          {{ 'GLOBAL.YES' | translate }}
        </span>
        <span *ngIf="!docInfo?.IsSignaturesPresent">
          <i class="rt-icon rt-error1 and-text text-danger justify-content-start me-1"></i>
          {{ 'GLOBAL.NO' | translate }}
        </span>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-6 py-1">
      <mat-label class="w-100 d-block mb-0 fw-bold">
        <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.SIZE' | translate }} </span>
      </mat-label>
      <div class="w-100">
        <span *ngIf="docInfo?.Size">
          {{docInfo?.Size}}
        </span>
        <span class="d-inline-block" *ngIf="!docInfo?.Size">
          {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
        </span>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-6 py-1">
      <mat-label class="w-100 d-block mb-0 fw-bold">
        <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.TITLE' | translate }} </span>
      </mat-label>
      <div class="w-100">
        <span *ngIf="docInfo?.Title">
          {{docInfo?.Title}}
        </span>
        <span class="d-inline-block" *ngIf="!docInfo?.Title">
          {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
        </span>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-6 py-1">
      <mat-label class="w-100 d-block mb-0 fw-bold">
        <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.AUTHOR' | translate }} </span>
      </mat-label>
      <div class="w-100">
        <span *ngIf="docInfo?.Author">
          {{docInfo?.Author}}
        </span>
        <span class="d-inline-block" *ngIf="!docInfo?.Author">
          {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
        </span>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-6 py-1">
      <mat-label class="w-100 d-block mb-0 fw-bold">
        <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.CREATOR' | translate }} </span>
      </mat-label>
      <div class="w-100">
        <span *ngIf="docInfo?.Creator">
          {{docInfo?.Creator}}
        </span>
        <span class="d-inline-block" *ngIf="!docInfo?.Creator">
          {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
        </span>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-6 py-1">
      <mat-label class="w-100 d-block mb-0 fw-bold">
        <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.PRODUCER' | translate }} </span>
      </mat-label>
      <div class="w-100">
        <span *ngIf="docInfo?.Producer">
          {{docInfo?.Producer}}
        </span>
        <span class="d-inline-block" *ngIf="!docInfo?.Producer">
          {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
        </span>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-6 py-1">
      <mat-label class="w-100 d-block mb-0 fw-bold">
        <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.PDF-VERSION' | translate }} </span>
      </mat-label>
      <div class="w-100">
        <span *ngIf="docInfo?.PDFFormatVersion">
          {{docInfo?.PDFFormatVersion}}
        </span>
        <span class="d-inline-block" *ngIf="!docInfo?.PDFFormatVersion">
          {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
        </span>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-6 py-1">
      <mat-label class="w-100 d-block mb-0 fw-bold">
        <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.LANGUAGE' | translate }} </span>
      </mat-label>
      <div class="w-100">
        <span *ngIf="docInfo?.Language">
          {{docInfo?.Language}}
        </span>
        <span class="d-inline-block" *ngIf="!docInfo?.Language">
          {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
        </span>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-6 py-1">
      <mat-label class="w-100 d-block mb-0 fw-bold">
        <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.CREATION-DATE' | translate }} </span>
      </mat-label>
      <div class="w-100">
        <span *ngIf="docInfo?.CreationDate">
          {{(docInfo?.CreationDate) ? (docInfo?.CreationDate | dateMultiLang:currentLang) : ('WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate) }}
        </span>
        <span class="d-inline-block" *ngIf="!docInfo?.CreationDate">
          {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
        </span>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-6 py-1">
      <mat-label class="w-100 d-block mb-0 fw-bold">
        <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.MOD-DATE' | translate }} </span>
      </mat-label>
      <div class="w-100">
        <span *ngIf="docInfo?.ModDate">
          {{(docInfo?.ModDate) ? (docInfo?.ModDate | dateMultiLang:currentLang) : ('WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate) }}
        </span>
        <span class="d-inline-block" *ngIf="!docInfo?.ModDate">
          {{'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.LABELS.NO-INFO' | translate}}
        </span>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions class="w-100">
  <button mat-stroked-button color="primary" class="ms-auto" [mat-dialog-close]="false">
    <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
    <span *ngIf="!isMobile">{{ 'WEB-SIGN.SIGNTRUST-LIB.CLOSE' | translate }}</span>
  </button>
</div>
